import { render, staticRenderFns } from "./CloseSegmentationModal.vue?vue&type=template&id=08066aa3&scoped=true&"
import script from "./CloseSegmentationModal.vue?vue&type=script&lang=js&"
export * from "./CloseSegmentationModal.vue?vue&type=script&lang=js&"
import style0 from "./CloseSegmentationModal.vue?vue&type=style&index=0&id=08066aa3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08066aa3",
  null
  
)

export default component.exports